export const getIsHighContrast = () =>
  window.localStorage.getItem('isHighContrast') === 'true'

export const setIsHighContrast = val =>
  window.localStorage.setItem('isHighContrast', `${val}`)

export const getFontSize = () =>
  Number(window.localStorage.getItem('fontSize')) || 0

export const setFontSize = val =>
  window.localStorage.setItem('fontSize', `${val}`)

export const getProviderNewsVersion = () =>
  Number(window.localStorage.getItem('providerNewsVersion')) || 0

export const setProviderNewsVersion = val =>
  window.localStorage.setItem('providerNewsVersion', `${val}`)
